<div class="page-layout carded left-sidebar inner-scroll" style="overflow-y: scroll;">
    <fuse-sidebar class="sidebar" name="order-main-sidebar" position="left" lockedOpen="gt-md">
        <file-main-sidebar></file-main-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">
        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
            <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                  fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                <div class="h2 mb-24">{{'File data'|translate}}</div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                    <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                        <mat-label>{{'Name'|translate}}</mat-label>
                        <input matInput formControlName="name" required>
                        <mat-error>{{'Name is required!'|translate}}</mat-error>
                    </mat-form-field>

                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                    <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                        <mat-label>{{'Tag'|translate}}</mat-label>
                        <input matInput formControlName="tag" required>
                        <mat-error>{{'Tag is required!'|translate}}</mat-error>
                    </mat-form-field>

                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-checkbox formControlName="gdprDocument" fxFlex="100">
                        <mat-label>{{'GDPR document'|translate}}</mat-label>
                    </mat-checkbox>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-checkbox formControlName="applicationRegulationsDocument" fxFlex="100">
                        <mat-label>{{'Application regulations document'|translate}}</mat-label>
                    </mat-checkbox>
                </div>

                <table>
                    <tr>
                        <td>
                            <div class="center">
                                <div class="container" appDnd (fileDropped)="onFileDropped($event)">
                                    <input type="file" #fileDropRef id="fileDropRef" multiple
                                           (change)="fileBrowseHandler($event.target.files)"/>
                                    <mat-icon class="nav-link-icon">cloud_upload</mat-icon>
                                    <h3>{{'Drag and drop file here'|translate}}</h3>
                                    <h3>{{'or'|translate}}</h3>
                                    <label for="fileDropRef">{{'Browse for file'|translate}}</label>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div fxLayout="row" class="files-list">
                                <div class="single-file" *ngFor="let file of files; let i = index">
                                    <!--        <img src="assets/img/dnd/ic-file.svg" width="45px" alt="file">-->
                                    <div class="info">
                                        <h4 class="name">
                                            {{ file?.name }}
                                        </h4>
                                        <p class="size">
                                            {{ formatBytes(file?.size) }}
                                        </p>
                                        <app-progress [progress]="file?.progress"></app-progress>
                                    </div>
                                    <!--        <img src="assets/img/dnd/ic-delete-file.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i)">-->
                                </div>
                            </div>
                        </td>
                    </tr>

                </table>
                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button mat-raised-button type="submit" color="accent">
                            {{'Save'|translate}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
